module.exports = __webpack_public_path__ + "assets/931ca49bc3419ea915ae7a0c2aad3e19.svg";